
import { useState, useCallback, useEffect } from 'react';
import {
    CircularProgress,
    Grid,
    TextField,
    Autocomplete,
    Button,
    FormControlLabel,
    Switch,
    MenuItem,
    InputAdornment
} from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import getDayjs from "../../../../context/DateInstance";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from "../../../../context/NotificationContext";
import { communicationReceivedVia, communicationsExternalTypes } from '../../../../utils/lists';
import { InputValidationMessage } from '../../../inputs/CustomField';
import UploadFilesDrive from '../../../files/UploadFiles';
import { useAuth } from "../../../../context/AuthContext";

const communicationFields = [
    { key: "fechaRecepcionDocumento", required: false },
    { key: "fechaDocumento", required: false },
    { key: "noDocumento", required: false },
    { key: "tipoDocumento", required: false },
    { key: "subtipoDocumento", required: false },
    { key: "viaRecepcion", required: true },
    { key: "numeroCopias", required: false },
    { key: "personaContacto", required: false },
    { key: "institucionEmpresa", required: true },
    { key: "representanteLegal", required: false },
    { key: "asunto", required: true },
    { key: "anexos", required: false },
    { key: "monto", required: false },
    { key: "dirigidoA", required: false },
    { key: "departamento", required: false }
];



export default function CommunicationsReceivedModalForm({ onClose, communication = {} }) {

    const axios = useAxios();
    const [selectedValuesToEdit, selectValuesToEdit] = useState({ ...communication });
    const [filterName, setFilterName] = useState("");
    const [filterNameUser, setFilterNameUser] = useState("");
    const [openOrganizationList, setOpenOrganizationList] = useState(false);
    const [openTypesList, setOpenTypeList] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingOrg, setLoadingOrg] = useState(false);
    const [organizationList, setorganizationList] = useState([]);
    const { showSnackbar } = useNotification();
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [adjuntos, setAdjuntos] = useState(communication?.files?.length > 0 ? true : false)
    const [openSignatureInput, setOpenSignatureInput] = useState(false);
    const [signatureUsers, setSignatureUsers] = useState([]);
    const { currentUser } = useAuth()

    const onChangeValues = async (e) => {
        selectValuesToEdit({ ...selectedValuesToEdit, [e.target.name]: e.target.value })
    }


    const USERS_API = `/users?page=1&limit=10&displayName=${filterNameUser}`


    const getOrgs = useCallback(async () => {
        try {
            setUserList([])
            setLoading(true);
            const { data } = await axios.get(USERS_API);
            setUserList(data.data.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, USERS_API, setUserList, setLoading, filterName]);

    const getUserSignature = useCallback(async () => {
        try {
            setUserList([])
            setLoading(true);
            const { data } = await axios.get(`/users?page=1&limit=1000000&signatureCommunication=${true}`);
            setSignatureUsers(data.data.list);

        } finally {
            setLoading(false);
        }
    }, [axios, USERS_API, setUserList, setLoading, filterName]);

    const saveCommunication = async () => {
        try {

            let error = false
            communicationFields.forEach(value => {

                if (value.key === "numeroCopias") {
                    selectedValuesToEdit[value.key] = Number(selectedValuesToEdit[value.key] || 0)
                }

                if (value.key === "monto") {
                    const keyValue = selectedValuesToEdit[value.key]
                    const rawValue = Number(keyValue ? keyValue.toString().replace(",", "") : "0");
                    selectedValuesToEdit[value.key] = Number(rawValue.toFixed(2));
                }

                if (!selectedValuesToEdit[value.key] && value.required) {
                    error = true; selectedValuesToEdit[value.key] = Number(selectedValuesToEdit[value.key])
                }
            })

            if (error) {
                return
            }

            setIsSubmitting(true)
            const body = { ...selectedValuesToEdit }

            if (body._id) {

                await axios.put(`/communications/updateReceived/${body._id}`, body);

            } else {

                await axios.post(`/communications/createReceived`, body);
                selectValuesToEdit({})
            }

            showSnackbar({ severity: "success", title: "Guardado", message: "Se ha guardado la comunicación correctamente." });
            onClose();
        } catch (error) {

            const message = error?.response?.data?.message || "Ha ocurrido un error al guardar."
            showSnackbar({ severity: "error", title: "Error", message });

        } finally {
            setIsSubmitting(false);
        }
    }

    const getOrganizations = useCallback(async () => {
        try {
            const organizationApi = `/personalities/organizations?page=${1}&limit=30${filterName ? `&nombre=${filterName}` : ''}&role=${"Soporte"}`
            setorganizationList([])
            setLoadingOrg(true);
            const { data } = await axios.get(organizationApi);
            setorganizationList(data?.data?.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingOrg(false);
        }
    }, [axios, setLoadingOrg, filterName]);


    useEffect(() => {
        getOrganizations()
    }, [filterName])


    useEffect(() => {
        getOrgs()
    }, [getOrgs, filterNameUser])


    useEffect(() => {

        selectValuesToEdit({
            ...selectedValuesToEdit,
            fechaRecepcionDocumento: selectedValuesToEdit.fechaRecepcionDocumento || getDayjs(),
            fechaDocumento: selectedValuesToEdit.fechaDocumento || getDayjs()
        })
    }, [])

    useEffect(() => {
        getUserSignature()
    }, [getUserSignature])


    return (

        <Grid container spacing={2} mb={2}>
            <Grid container item xs={12} spacing={2}>

                {/* Vía de Recepción */}
                <Grid item xs={12} md={6} mt={1}>

                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openTypesList}
                        onOpen={() => {
                            setOpenTypeList(true);
                        }}
                        onClose={() => {
                            setOpenTypeList(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.description === value.description}
                        getOptionLabel={(option) =>
                            option.description
                        }
                        options={communicationReceivedVia}
                        defaultValue={{ _id: selectedValuesToEdit?.viaRecepcion?._id || "", description: selectedValuesToEdit?.viaRecepcion?.description || "" }}
                        onChange={(_e, value) => {
                            if (!value) {
                                setFilterNameUser("")
                                onChangeValues({ target: { name: "viaRecepcion", value: null } })
                                return
                            }
                            onChangeValues({ target: { name: "viaRecepcion", value } })
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Vía de recepción"
                                onChange={(e) => {
                                    setFilterNameUser(e.target.value)
                                }}
                                InputProps={{
                                    ...params.InputProps
                                }}
                            />
                        )}
                    />
                    {(!selectedValuesToEdit?.viaRecepcion?._id && communicationFields.find(value => value.key === "viaRecepcion")?.required) && <InputValidationMessage message={"Es requerido este campo."} />}
                </Grid>


                {/* Fecha Recepción Documento */}
                <Grid item xs={12} md={6} mt={1}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Fecha Recepción Documento Externo"
                            value={getDayjs(selectedValuesToEdit.fechaRecepcionDocumento || null)}
                            onChange={(value) =>
                                onChangeValues({
                                    target: { name: "fechaRecepcionDocumento", value }
                                })
                            }
                            sx={{
                                width: "100%",
                                '& .MuiInputBase-input': {
                                    fontSize: '15px',
                                    padding: '8.5px 32px 8.5px 14px',
                                }
                            }}
                        />
                    </LocalizationProvider>
                    {(!selectedValuesToEdit?.fechaRecepcionDocumento && communicationFields.find(value => value.key === "fechaRecepcionDocumento")?.required) && (
                        <InputValidationMessage message="Es requerido este campo." />
                    )}
                </Grid>

                {/* Fecha de Documento */}
                <Grid item xs={12} md={6} mt={1}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Fecha de Documento Externo"
                            value={getDayjs(selectedValuesToEdit.fechaDocumento || null)}
                            onChange={(value) =>
                                onChangeValues({ target: { name: "fechaDocumento", value } })
                            }
                            sx={{
                                width: "100%",
                                '& .MuiInputBase-input': {
                                    fontSize: '15px',
                                    padding: '8.5px 32px 8.5px 14px',
                                }
                            }}
                        />
                    </LocalizationProvider>
                    {(!selectedValuesToEdit?.fechaDocumento && communicationFields.find(value => value.key === "fechaDocumento")?.required) && (
                        <InputValidationMessage message="Es requerido este campo." />
                    )}
                </Grid>

                {/* No. Documento */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="No. Documento Externo"
                        name="noDocumento"
                        value={selectedValuesToEdit?.noDocumento || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {(!selectedValuesToEdit?.noDocumento && communicationFields.find(value => value.key === "noDocumento")?.required) && (
                        <InputValidationMessage message="Es requerido este campo." />
                    )}
                </Grid>

                {/* Tipo de Documento */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Tipo de Documento Externo"
                        name="tipoDocumento"
                        value={selectedValuesToEdit?.tipoDocumento || ""}
                        fullWidth
                        onChange={onChangeValues}
                        select
                    >
                        {communicationsExternalTypes.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    {(!selectedValuesToEdit?.tipoDocumento && communicationFields.find(value => value.key === "tipoDocumento")?.required) && (
                        <InputValidationMessage message="Es requerido este campo." />
                    )}
                </Grid>

                {/* Subtipo Documento */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Subtipo Documento Externo"
                        name="subtipoDocumento"
                        value={selectedValuesToEdit?.subtipoDocumento || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {(!selectedValuesToEdit?.subtipoDocumento && communicationFields.find(value => value.key === "subtipoDocumento")?.required) && (
                        <InputValidationMessage message="Es requerido este campo." />
                    )}
                </Grid>



                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Número de hojas"
                        name="numeroCopias"
                        value={selectedValuesToEdit?.numeroCopias || ""}
                        fullWidth
                        type="number"
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.numeroCopias && communicationFields.find(value => value.key === "numeroCopias")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                {/* Persona de Contacto */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Persona de Contacto"
                        name="personaContacto"
                        value={selectedValuesToEdit?.personaContacto || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.personaContacto && communicationFields.find(value => value.key === "personaContacto")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                {/* Institución / Empresa */}
                <Grid item xs={12} md={6} mt={1}>

                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openOrganizationList}
                        onOpen={() => {
                            setOpenOrganizationList(true);
                        }}
                        onClose={() => {
                            setOpenOrganizationList(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
                        getOptionLabel={(option) =>
                            option.nombre
                        }
                        options={organizationList}
                        defaultValue={{ _id: selectedValuesToEdit?.institucionEmpresa?._id || "", nombre: selectedValuesToEdit?.institucionEmpresa?.description || "" }}
                        onChange={(_e, value) => {
                            if (!value) {
                                setFilterName("")
                                onChangeValues({ target: { name: "institucionEmpresa", value: null } })
                                return
                            }
                            onChangeValues({ target: { name: "institucionEmpresa", value: { _id: value._id, description: value.nombre } } })
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Institución / Empresa"
                                onChange={(e) => {
                                    setFilterName(e.target.value)
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loadingOrg ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    {
                        (!selectedValuesToEdit?.institucionEmpresa && communicationFields.find(value => value.key === "institucionEmpresa")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>


                {/* Representante Legal */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Representante Legal"
                        name="representanteLegal"
                        value={selectedValuesToEdit?.representanteLegal || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.representanteLegal && communicationFields.find(value => value.key === "representanteLegal")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                {/* Monto */}
                <Grid item xs={12} md={6} mt={1}>
                    <NumericFormat
                        value={selectedValuesToEdit.monto || ""}
                        customInput={TextField}
                        size="small"
                        label="Monto"
                        name="monto"
                        fullWidth
                        onChange={onChangeValues}
                        valueIsNumericString
                        thousandSeparator={true}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$RDS</InputAdornment>
                        }}
                    />
                    {
                        (!selectedValuesToEdit?.monto && communicationFields.find(value => value.key === "monto")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                {/* Dirigido A */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Dirigido A"
                        name="dirigidoA"
                        value={selectedValuesToEdit?.dirigidoA || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.dirigidoA && communicationFields.find(value => value.key === "dirigidoA")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                {/* Departamento */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Departamento"
                        name="departamento"
                        value={selectedValuesToEdit?.signatureUser?.department?.description || ""}
                        fullWidth
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.departamento && communicationFields.find(value => value.key === "departamento")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                    <Autocomplete
                        size="small"
                        fullWidth
                        id="support_assigned"
                        open={openSignatureInput}
                        onOpen={() => {
                            setOpenSignatureInput(true);
                        }}
                        onClose={() => {
                            setOpenSignatureInput(false);
                        }}
                        isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                        getOptionLabel={(option) =>
                            option.displayName
                        }
                        options={signatureUsers}
                        defaultValue={{ _id: selectedValuesToEdit?.signatureUser?._id || "", displayName: selectedValuesToEdit?.signatureUser?.displayName || "" }}
                        onChange={(_e, value) => {
                            if (!value) {
                                setFilterName("")
                                onChangeValues({ target: { name: "signatureUser", value: null } })
                                return
                            }
                            onChangeValues(
                                {
                                    target: {
                                        name: "signatureUser",
                                        value: {
                                            _id: value._id,
                                            displayName: value.displayName,
                                            charge: value.jobTitle,
                                            department: {
                                                description: value.department,
                                                departmentShortName: value.departmentShortName,

                                            }
                                        }
                                    }
                                })
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                size="small"
                                {...params}
                                label="Responsable de firma"
                                onChange={(e) => {
                                    setFilterName(e.target.value)
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                    <TextField size="small" label="Cargo del responsable de firma" name="recipientCharge" value={selectedValuesToEdit?.signatureUser?.charge || ""} fullWidth />
                </Grid>


                {/* Asunto */}
                <Grid item xs={12} md={6} mt={1}>
                    <TextField
                        size="small"
                        label="Asunto"
                        name="asunto"
                        value={selectedValuesToEdit?.asunto || ""}
                        fullWidth
                        multiline
                        rows={3}
                        onChange={onChangeValues}
                    />
                    {
                        (!selectedValuesToEdit?.asunto && communicationFields.find(value => value.key === "asunto")?.required) && (
                            <InputValidationMessage message="Es requerido este campo." />
                        )
                    }
                </Grid>


                <Grid item xs={12} >

                    <FormControlLabel control={<Switch checked={adjuntos} onChange={(e) => setAdjuntos(e.target.checked)} />} label="Adjuntos" />

                    {
                        adjuntos &&

                        <>
                            <Grid item xs={12} md={6} mt={1}>
                                <TextField size="small" value={selectedValuesToEdit?.filesComment || ""} label="Comentario de adjuntos" name="filesComment" multiline rows={3} fullWidth onChange={onChangeValues} />
                            </Grid>

                            <UploadFilesDrive
                                files={selectedValuesToEdit?.files || []}
                                onDelete={selectValuesToEdit}
                                onLoadFile={
                                    (files) => {
                                        onChangeValues({ target: { name: "files", value: files } })
                                        axios.put(`/communications/updateReceived/${selectedValuesToEdit?._id}`, { ...selectedValuesToEdit, files });
                                    }}
                            />
                        </>
                    }

                </Grid>


            </Grid>



        
                <Grid item sm={12} textAlign="right" mt={3}>
                    <Button variant="outlined" onClick={onClose}>
                       {(currentUser?.role?.some(role => role === "Registra comunicaciones externas")) ? "Cancelar" : "Cerrar"} 
                    </Button>
                    
                    { (currentUser?.role?.some(role => role === "Registra comunicaciones externas")) &&
                        <Button
                        sx={{ marginLeft: 2 }}
                        variant="contained"
                        onClick={saveCommunication}
                    >
                        {isSubmitting && (
                            <CircularProgress
                                size="15px"
                                sx={{ color: "white", marginRight: "6px" }}
                            />
                        )}
                        {isSubmitting ? "Guardando" : "Guardar"}
                    </Button>
                    }
                </Grid>
        </Grid>

    )
}